import React, { useEffect, useRef } from "react";
import { MdOutlineAssignmentTurnedIn } from "react-icons/md";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import Loader from "../Loader";
import active from "../../../src/assets/images/power-on.png";
import expire from "../../../src/assets/images/time.png";
import finish from "../../../src/assets/images/product.png";
import expiry from "../../../src/assets/images/expiry.png";
import data from "../../../src/assets/images/data.png";
import globe from "../../../src/assets/images/globe.png";
import calender from "../../../src/assets/images/calender.png";
import complete from "../../../src/assets/images/complete.png";
import activate from "../../../src/assets/images/off-button.png";

const UsageModal = ({ show, handleClose, eSimDetail, isLoading }) => {
  const modalRef = useRef(null);

  // Handle click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        handleClose();
      }
    };

    if (show) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [show, handleClose]);

  const formatDate = (date) =>
    date && date !== "0000-00-00 00:00:00"
      ? new Date(date).toLocaleString()
      : "N/A";

  const renderPackageHistory = (item) => {
    switch (item?.status_v2) {
      case "NOT_ACTIVE":
        return (
          <>
            <div className="fw-semibold d-flex my-2 align-items-center gap-2">
              <div
                style={{ width: "34%" }}
                className="d-flex align-items-center"
              >
                <MdOutlineAssignmentTurnedIn className="me-2" size={20} />
                <p className="mb-0">ISSUED</p>
              </div>
              <span
                className="fw-normal"
                style={{ marginLeft: "0em", width: "62%" }}
              >
                {formatDate(item?.createdAt)}
              </span>
            </div>
          </>
        );
      case "ACTIVE":
      case "EXPIRED":
      case "REFUNDED":
        return (
          <>
            <div className="fw-semibold d-flex my-2 align-items-center gap-2">
              <div
                style={{ width: "34%" }}
                className="d-flex align-items-center"
              >
                <img
                  src={active}
                  width={16}
                  height={16}
                  alt="activation icon"
                  className="me-2"
                />
                <p className="mb-0">ACTIVATION</p>
              </div>
              <span
                className="fw-normal"
                style={{ marginLeft: "0em", width: "62%" }}
              >
                {formatDate(item?.activated_at)}
              </span>
            </div>
            <div className="fw-semibold d-flex my-2 align-items-center gap-2">
              <div
                style={{ width: "34%" }}
                className="d-flex align-items-center"
              >
                <img
                  src={expire}
                  width={18}
                  height={18}
                  alt="expire icon"
                  className="me-2"
                />
                <p className="mb-0">
                  {item?.status_v2 === "REFUNDED" ? "REFUND" : "EXPIRY"}
                </p>
              </div>
              <span
                className="fw-normal"
                style={{ marginLeft: "0em", width: "62%" }}
              >
                {formatDate(item?.expired_at)}
              </span>
            </div>
          </>
        );
      case "FINISHED":
        return (
          <>
            <div className="fw-semibold d-flex my-2 align-items-center gap-2">
              <div
                style={{ width: "34%" }}
                className="d-flex align-items-center"
              >
                <img
                  src={active}
                  width={16}
                  height={16}
                  alt="activation icon"
                  className="me-2"
                />
                <p className="mb-0">ACTIVATION</p>
              </div>
              <span
                className="fw-normal"
                style={{ marginLeft: "0em", width: "62%" }}
              >
                {formatDate(item?.activated_at)}
              </span>
            </div>
            <div className="fw-semibold d-flex my-2 align-items-center gap-2">
              <div
                style={{ width: "34%" }}
                className="d-flex align-items-center"
              >
                <img
                  src={finish}
                  width={24}
                  height={24}
                  alt="activation icon"
                  className="me-2"
                />
                <p className="mb-0">FINISH</p>
              </div>
              <span
                className="fw-normal"
                style={{ marginLeft: "0em", width: "62%" }}
              >
                {formatDate(item?.finished_at)}
              </span>
            </div>
          </>
        );
      default:
        return null;
    }
  };

  // Function to get the badge color with opacity based on the status
  const getStatusColor = (status) => {
    switch (status) {
      case "NOT_ACTIVE":
        return "#D4B700"; // Darker yellow for better contrast
      case "ACTIVE":
        return "#008A5E"; // Darker green
      case "FINISHED":
      case "EXPIRED":
        return "#C00000"; // Darker red
      case "REFUNDED":
        return "#5A6268"; // Darker gray
      default:
        return "#6C757D"; // Bootstrap's default gray
    }
  };

  const renderNetworkDetails = () => {
    if (eSimDetail?.eSim?.tr_lastSeen === "0000-00-00 00:00:00") {
      return null;
    }

    return (
      <div className="card shadow-sm bg-light mb-3 rounded">
        <div className="card-body">
          <h5 className="card-title mb-0">NETWORK DETAILS</h5>
          <hr className="mb-0" />
          <div className="mt-3">
            <p className="mb-1">
              <strong className="fw-semibold">MOBILE NETWORK CODE:</strong>{" "}
              {eSimDetail?.eSim?.tr_mobileNetworkCode || "N/A"}
            </p>
            <p className="mb-1">
              <strong className="fw-semibold">NETWORK NAME:</strong>{" "}
              {eSimDetail?.eSim?.tr_networkName || "N/A"}
            </p>
            <p className="mb-1">
              <strong className="fw-semibold">NETWORK BRAND NAME:</strong>{" "}
              {eSimDetail?.eSim?.tr_networkBrandName || "N/A"}
            </p>
            <p className="mb-1">
              <strong className="fw-semibold">COUNTRY:</strong>{" "}
              {eSimDetail?.eSim?.tr_country || "N/A"}
            </p>
            <p className="mb-0">
              <strong className="fw-semibold">LAST SEEN:</strong>{" "}
              {formatDate(eSimDetail?.eSim?.tr_lastSeen)}
            </p>
            <p className="mb-0">
              <strong className="fw-semibold">IMEI:</strong>{" "}
              {eSimDetail?.eSim?.tr_imei === null
                ? "N/A"
                : eSimDetail?.eSim?.tr_imei}
            </p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div
      className={`modal fade ${show ? "show d-block" : ""}`}
      tabIndex="-1"
      style={{ backgroundColor: show ? "rgba(0, 0, 0, 0.5)" : "transparent" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content" ref={modalRef}>
          <div className="modal-header">
            <h5 className="modal-title">Usage</h5>
            <button
              type="button"
              className="btn-close"
              onClick={handleClose}
            ></button>
          </div>
          <div className="modal-body">
            {isLoading ? (
              <div
                style={{
                  height: "20vh",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "8em",
                }}
              >
                <Loader />
              </div>
            ) : (
              <>
                <div className="card shadow-sm bg-light mb-3 rounded">
                  <div className="card-body">
                    <p className="mb-1">
                      <strong className="fw-semibold">COVERAGE:</strong>{" "}
                      {eSimDetail?.eSim?.coverage}
                    </p>
                    <p className="mb-1">
                      <strong className="fw-semibold">PACKAGE:</strong>{" "}
                      {eSimDetail?.eSim?.packageName}
                    </p>
                    <p className="mb-1">
                      <strong className="fw-semibold">ICCID:</strong>{" "}
                      {eSimDetail?.eSim?.iccid}
                    </p>
                    {eSimDetail?.eSim?.sim_installation_status && (
                      <p className="mb-1">
                        {eSimDetail?.eSim?.carrier_product_type === "esim" ? (
                          <strong className="fw-semibold">ESIM STATUS: </strong>
                        ) : (
                          <strong className="fw-semibold">SIM STATUS: </strong>
                        )}
                        {eSimDetail?.eSim?.sim_installation_status}
                      </p>
                    )}
                  </div>
                </div>
                <div
                  style={{
                    maxHeight: "48em",
                    overflowY: "scroll",
                  }}
                >
                  {/* Render Network Details */}
                  {renderNetworkDetails()}
                </div>

                <h5 className="card-title mb-0">
                  {eSimDetail?.eSim?.carrier_product_type === "esim"
                    ? "eSIM PACKAGES"
                    : "SIM PACKAGES"}
                </h5>
                <hr className="mb-0" />
                <div style={{ maxHeight: "26em", overflowY: "scroll" }}>
                  {eSimDetail?.package_history.map((esim, index) => {
                    return (
                      <div
                        className="card shadow-sm bg-light mb-3 mt-5 rounded-bottom rounded-top-end position-relative me-1"
                        key={index}
                      >
                        <div className="card-body">
                          <div className="">
                            {/* Status Badge - Top Left */}
                            <div
                              className="position-absolute start-0 py-1 px-2 px-sm-3 fw-semibold rounded-top-end border-0 shadow-sm fs-6 fs-sm-5"
                              style={{
                                backgroundColor: getStatusColor(esim.status_v2),
                                color: "white",
                                zIndex: 1,
                                transform: "translateY(-1px)",
                                top: "-28px",
                              }}
                            >
                              {esim?.status_v2.replace("_", " ")}
                            </div>
                            {/* Status Badge - Top Right */}
                            {esim?.package_number && (
                              <div
                                class="position-absolute end-0 py-1 px-2 px-sm-3 fw-semibold border fs-6 fs-sm-5"
                                style={{
                                  backgroundColor: "#F8F9FA",
                                  color: "black",
                                  zIndex: 1,
                                  transform: "translateY(-1px)",
                                  top: "-28px",
                                }}
                              >
                                Package # {esim?.package_number}
                              </div>
                            )}

                            {esim?.createdAt && (
                              <div className="d-flex justify-content-between align-items-center px-2  border-secondary pb-1">
                                <div className="d-flex align-items-center gap-sm-2 gap-1">
                                  <MdOutlineAssignmentTurnedIn className="fs-4 fs-sm-3 text-start" />
                                  <p className="fs-6 fs-sm-5 fw-semibold text-body mb-0">
                                    ISSUED
                                  </p>
                                </div>
                                <span className="text-body text-end small fs-sm-6">
                                  {formatDate(esim?.createdAt)}
                                </span>
                              </div>
                            )}

                            {esim?.activated_at && (
                              <div className="d-flex justify-content-between align-items-center px-2  border-secondary pb-1 mt-2">
                                <div className="d-flex align-items-center gap-sm-2 gap-1">
                                  <img
                                    src={activate}
                                    alt="activate Icon"
                                    width={18}
                                    height={18}
                                    className="img-fluid"
                                  />
                                  <p className="fs-6 fs-sm-5 fw-semibold text-body mb-0">
                                    ACTIVATED
                                  </p>
                                </div>
                                <span className="text-body text-end small fs-sm-6">
                                  {formatDate(esim?.activated_at)}
                                </span>
                              </div>
                            )}

                            {esim?.finished_at && (
                              <div className="d-flex justify-content-between align-items-center px-2 border-secondary pb-1 mt-2">
                                <div className="d-flex align-items-center gap-sm-2 gap-1">
                                  <img
                                    src={complete}
                                    alt="complete Icon"
                                    width={18}
                                    height={18}
                                    className="img-fluid"
                                  />
                                  <p className="fs-6 fs-sm-5 fw-semibold text-body mb-0">
                                    FINISHED
                                  </p>
                                </div>
                                <span className="text-body text-end small fs-sm-6">
                                  {formatDate(esim?.finished_at)}
                                </span>
                              </div>
                            )}

                            {esim?.expired_at && (
                              <div className="d-flex justify-content-between align-items-center px-2 border-secondary pb-1 mt-2">
                                <div className="d-flex align-items-center gap-sm-2 gap-1">
                                  <img
                                    src={expiry}
                                    alt="activate Icon"
                                    width={18}
                                    height={18}
                                    className="img-fluid"
                                  />
                                  <p className="fs-6 fs-sm-5 fw-semibold text-body mb-0">
                                    EXPIRY
                                  </p>
                                </div>
                                <span className="text-body text-end small fs-sm-6">
                                  {formatDate(esim?.expired_at)}
                                </span>
                              </div>
                            )}

                            {esim?.activation_validity && (
                              <div className="d-flex justify-content-between align-items-center px-2 border-secondary pb-1 mt-2">
                                <div className="d-flex align-items-center gap-sm-2 gap-1">
                                  <img
                                    src={expiry}
                                    alt="activation validity Icon"
                                    width={18}
                                    height={18}
                                    className="img-fluid"
                                  />
                                  <p className="fs-6 fs-sm-5 fw-semibold text-body mb-0">
                                    ACTIVATION VALIDITY
                                  </p>
                                </div>
                                <span className="text-body text-end small fs-sm-6">
                                  {formatDate(esim?.activation_validity)}
                                </span>
                              </div>
                            )}

                            <hr />

                            <div className="d-flex flex-row-reverse align-items-center justify-content-between gap-2 px-sm-4 px-xs-2 px-0 pt-2">
                              <div
                                className="text-center position-relative"
                                style={{ width: 125, height: 125 }}
                              >
                                <CircularProgressbar
                                  value={esim?.circular_value || 0}
                                  // text={`${esim?.remaining_data || 0} MB`}
                                  text={""}
                                  styles={buildStyles({
                                    textSize: "14px",
                                    strokeLinecap: "round",
                                    textSize: "16px",
                                    pathTransitionDuration: 0.5,
                                    pathColor: "#FD5C57",
                                    textColor: "#1A202C",
                                    trailColor: "#D5D5D5",
                                  })}
                                />
                                <div
                                  className="fw-semibold fs-6 position-absolute"
                                  style={{
                                    fontSize: "16px",
                                    color: "#1A202C",
                                    left: "20%",
                                    top: "38%",
                                    lineHeight: "1em",
                                  }}
                                >
                                  {esim?.remaining_data || 0} MB
                                  <p className="mb-0 fs-6 fw-normal ">
                                    REMAINING
                                  </p>
                                </div>
                              </div>
                              <div className="d-flex flex-column gap-md-3 gap-2">
                                {/* Country Row */}
                                <div className="d-flex align-items-center gap-2 gap-md-3">
                                  <img
                                    src={globe}
                                    alt="Expiry Icon"
                                    width={20}
                                    height={20}
                                    className="img-fluid"
                                  />
                                  <p className=" fs-6 fw-semibold mb-0 text-body">
                                    {esim.coverage || "Country"}
                                  </p>
                                </div>

                                {/* Validity Row */}
                                <div className="d-flex align-items-center gap-2 gap-md-3">
                                  <img
                                    src={calender}
                                    alt="calender Icon"
                                    width={20}
                                    height={20}
                                    className="img-fluid"
                                  />

                                  <p className="fs-6 fs-md-5 mb-0 fw-medium text-body">
                                    {esim.validity} Days
                                  </p>
                                </div>

                                {/* Data Row */}
                                <div className="d-flex align-items-center gap-2 gap-md-3">
                                  <img
                                    src={data}
                                    alt="Data Icon"
                                    width={16}
                                    height={16}
                                    className="img-fluid"
                                  />

                                  <p className="fs-6 fs-md-5 mb-0 fw-medium text-body">
                                    {esim.data || "Unknown"}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UsageModal;
